import React from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'

import Header from './components/Header'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'
import FeaturePillars from './components/FeaturePillars'
import BottomContactSection from './components/BottomContactSection'
import AcServicePriceSection from './components/AcServicePriceSection'

import HomePage from './pages/HomePage'
import ServiceDetailPage from './pages/ServiceDetailPage'
import ReferencePage from './pages/ReferencePage'
import KontaktPage from './pages/KontaktPage'
import NotFoundPage from './pages/NotFoundPage'
import ForbiddenPage from './pages/ForbiddenPage'

function AppContent() {
  const location = useLocation()
  const isHomePage = location.pathname === '/' || location.pathname === ''
  const isAcServicePage = location.pathname === '/a-c-service' || location.pathname === '/a-c-service/'

  return (
    <div className="flex flex-col min-h-screen bg-slate-50 text-slate-900 font-sans antialiased">
      <Header />
      <main className="flex-grow">
        <Routes>
          {/* Home */}
          <Route path="/" element={<HomePage />} />

          {/* Services (Vi tilbyder) */}
          <Route path="/a-c-service" element={<ServiceDetailPage forcedSlug="a-c-service" />} />
          <Route path="/a-c-service/" element={<ServiceDetailPage forcedSlug="a-c-service" />} />

          <Route path="/daek-og-faelge" element={<ServiceDetailPage forcedSlug="daek-og-faelge" />} />
          <Route path="/daek-og-faelge/" element={<ServiceDetailPage forcedSlug="daek-og-faelge" />} />

          <Route path="/gearkasse-service" element={<ServiceDetailPage forcedSlug="gearkasse-service" />} />
          <Route path="/gearkasse-service/" element={<ServiceDetailPage forcedSlug="gearkasse-service" />} />

          <Route path="/gearkasse-skylning" element={<ServiceDetailPage forcedSlug="gearkasse-skylning" />} />
          <Route path="/gearkasse-skylning/" element={<ServiceDetailPage forcedSlug="gearkasse-skylning" />} />

          <Route path="/kundebil" element={<ServiceDetailPage forcedSlug="kundebil" />} />
          <Route path="/kundebil/" element={<ServiceDetailPage forcedSlug="kundebil" />} />

          <Route path="/reparation" element={<ServiceDetailPage forcedSlug="reparation" />} />
          <Route path="/reparation/" element={<ServiceDetailPage forcedSlug="reparation" />} />

          <Route path="/service" element={<ServiceDetailPage forcedSlug="service" />} />
          <Route path="/service/" element={<ServiceDetailPage forcedSlug="service" />} />

          <Route path="/udskiftning-af-tandrem-og-taktkaede" element={<ServiceDetailPage forcedSlug="udskiftning-af-tandrem-og-taktkaede" />} />
          <Route path="/udskiftning-af-tandrem-og-taktkaede/" element={<ServiceDetailPage forcedSlug="udskiftning-af-tandrem-og-taktkaede" />} />

          <Route path="/walnut-blaster" element={<ServiceDetailPage forcedSlug="walnut-blaster" />} />
          <Route path="/walnut-blaster/" element={<ServiceDetailPage forcedSlug="walnut-blaster" />} />

          {/* Reference */}
          <Route path="/reference" element={<ReferencePage />} />
          <Route path="/reference/" element={<ReferencePage />} />

          {/* Kontakt */}
          <Route path="/kontakt" element={<KontaktPage />} />
          <Route path="/kontakt/" element={<KontaktPage />} />

          {/* Status error pages */}
          <Route path="/403" element={<ForbiddenPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>

      {!isHomePage && (
        <>
          <FeaturePillars />
          {isAcServicePage && <AcServicePriceSection />}
          <BottomContactSection />
        </>
      )}

      <Footer />
    </div>
  )
}

export default function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
      <AppContent />
    </HelmetProvider>
  )
}
